module.exports = __webpack_public_path__ + "static/media/kinetic-energy.071fe559.svg";